<app-gift-options-slider
    [headline]="'giftOptions.cards.selectCard' | translateSafe"
    [selectedOptionIndex]="selectedOptionIndex"
>
    <app-gift-option
        class="gift-option"
        *ngFor="let option of options; trackBy: trackByVariantNo"
        [displayPrice]="option.displayPrice"
        [variantNo]="option.variantNo"
        [name]="option.cardName"
        [image]="option.image"
        [isSelected]="selectedOption?.variantNo === option.variantNo"
        (optionClick)="selectCard($event)"
    ></app-gift-option>
</app-gift-options-slider>

<span class="gift-options-note" *ngIf="'giftOptions.cards.note' | translateSafe as note">{{ note }}</span>
